module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("7")])])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "chaphead-image2"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("The Hunt")])])]), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("M")]), _vm._v("artin Luther King was rushed to St. Joseph’s Hospital, where a team of doctors made a final, futile effort to revive him. In the meantime, the Memphis police poured over the rooming house and the surrounding neighborhood. When the chief of homicide, N. E. Zachary, went inside Room 5B, he put his head through the window and could see the Lorraine just two hundred feet away."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-1",
      "id": "ch07-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" It was evident that someone had used the room to monitor the motel, waiting for King to come outside: A dresser had been pushed away from the window and replaced by a straight-back chair; a strap from a pair of binoculars was on the floor; the window was three-quarters open and the curtains pushed wide. However, to use the window, the viewer had to lean partially outside. Room 5B, therefore, was not an ideal sniper’s nest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The bathroom, down the hall, was the best spot for a clear shot. Even there, the shooter would have had to stand in the large cast-iron tub, located directly under the window. The window was open, and a small mesh screen had been pushed outside into the backyard. Scuff marks were in the tub, and there was what looked like a partial palm print on the wall. Zachary also noticed a very tiny indentation on the windowsill, as though the shooter had rested his rifle there when making the shot."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-2",
      "id": "ch07-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('p', {
    staticClass: "normal1"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("How had the assassin managed to get away when police were on the scene within minutes? The shooting had taken place at approximately 6:01 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". Although the police surveillance team at the fire station knew about it immediately, it was not until 6:03, after receiving confirmation, that the dispatcher put the news on the air."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-3",
      "id": "ch07-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" Patrol cars and units from a wide area then headed toward the Lorraine. It took five minutes after the shooting before the dispatcher ordered the two-block area around the motel and the rooming house sealed off."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-4",
      "id": "ch07-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" By 6:08 there was a description of the suspect as a young, well-dressed white male, and two minutes later, the late-model white Mustang was broadcast as a possible getaway car."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-5",
      "id": "ch07-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" By the time of the Mustang report, the shooter was likely in another state. From the rooming house, Arkansas was only six to seven minutes away to the west, and to the south, the Mississippi state line was about fifteen minutes away. The Memphis police dispatcher did broadcast a “Signal Q” to have all the downtown lights changed to red in the hope of slowing the fleeing assassin, but no all-points bulletin was issued to the neighboring states of Arkansas, Mississippi, Alabama, or Georgia. Also, contrary to Memphis police procedures, roadblocks were not set up at major arteries leading out of the city. The dispatcher later explained these serious lapses by claiming they were “attributable to the massive confusion and huge volume of radio traffic which erupted immediately following the assassination of Dr. King and which caused me to overlook the function of these duties.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-6",
      "id": "ch07-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" This meant that once the assassin crossed the state line, nobody would be looking for him or his car."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn07-07-1",
      "id": "fn07-1"
    }
  }, [_vm._v("*")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-7",
      "id": "ch07-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("And even within Memphis confines, less than half of the police cars and nearly a third of the force did not respond to any of the dispatcher broadcasts to engage in the hunt for the assassin. Police department officials later maintained it was necessary to keep the TACT units on alert for any rioting and looting that might occur following news of the assassination.")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn07-07-2",
      "id": "fn07-2"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The police at the scene began to interview witnesses, sweep the premises for fingerprints, and search the neighborhood for other evidence. However, the key to the crime was the covered bundle found in front of Canipe’s store. It contained not only the Remington rifle purchased six days earlier in Birmingham, but also the binoculars bought the day of the assassination, nine .30-06 bullets, some clothing, a section of "), _c('i', [_vm._v("The Commercial Appeal")]), _vm._v(" reporting that King was at the Lorraine, a transistor radio, and an assortment of toiletries in a fifteen-by-twenty-inch blue plastic overnight bag.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although murder is a state crime, the FBI had been brought in almost immediately on the supposition that the shooter may have crossed a state line. Within the next few days, as the country mourned or flared in anger over Dr. King’s violent death, more than 3,500 FBI agents were assigned to track down the assassin. It was the largest manhunt in the Bureau’s history. Cartha De-Loach, the FBI’s assistant director and Hoover’s trusted friend, was so confident of success that he bet Attorney General Ramsey Clark a bottle of sherry that the murderer would be caught within twenty-four hours."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-8",
      "id": "ch07-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("DeLoach lost his bet—but not for lack of trying. The FBI followed hundreds of leads in more than a dozen countries. The very next day, it traced the gun to Aeromarine Supply in Birmingham and had the name and description of the buyer, Harvey Lowmeyer. By April 11, one week after the shooting, the Bureau had traced a laundry mark on the T-shirt and shorts abandoned at the scene to the Home Service Laundry in Los Angeles, eighteen hundred miles away. Fortunately, the machine that had processed the number on the shorts had been used only between March 4 and March 18. The manager, Lucy Pinela, checked her records, it showed the number—02B-6—had been assigned to a Mr. Eric S. Galt. He had been bringing in his laundry since January 15."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-9",
      "id": "ch07-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Agents also traced a pair of flat-nose duckbill pliers found at the crime scene to Rompage Hardware, located only two blocks from the laundry."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-10",
      "id": "ch07-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Was the Galt who had been in Los Angeles for at least three months the same person as the Lowmeyer who had bought "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("the gun in Birmingham? The same man as the Willard who rented Room 5B the day of the assassination in Memphis? The physical descriptions indicated to the Bureau that it might be looking for one suspect using several aliases.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("The same day that the laundry and pliers were traced to Los Angeles, another break brought the FBI closer to the assassin. For six days, a white Mustang had been parked in the rear of an eight-hundred-unit low-cost housing project, Capitol Homes, in Atlanta. It had been noticed immediately because it seemed too expensive a sports car for the neighborhood. Several residents had actually seen the car arrive, and all described the man who drove it as trim, white, about thirty-five years old, wearing a dark suit and white shirt. Every day the car remained it became more of a topic of discussion within the housing project. On April 10, Mrs. John Riley called the local FBI office and told an agent about the suspicious auto. The agent, one of dozens whose only job was to field the flood of incoming tips, suggested she call the Atlanta police, which she did. Two policemen came by that night and looked the car over carefully. The next day, April 11, FBI agents swarmed into the area and towed the car away."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-11",
      "id": "ch07-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" A quick check revealed it was registered to an Eric Starvo Galt, 2608 South Highland Avenue, Birmingham. His 1967 application for an Alabama license showed he was five-eleven, thirty-six years old, and had brown hair and blue eyes, similar to the description given by the witnesses who had dealt with Harvey Lowmeyer when he bought a rifle, and to John Willard when he rented Room 5B in Memphis."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-12",
      "id": "ch07-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the name Galt meant nothing to the Atlanta police, it filled in a significant part of the puzzle for the FBI. The day before the car was found, two agents were canvassing all the hotels in the Memphis area for anyone resembling a white man with a white Mustang. At the New Rebel Motel they discovered that an Eric S. Galt, of 2608 South Highland Avenue, Birmingham, had been there the night of April 3 and checked out early on April 4. That meant that Galt, whose clothes had been found in Memphis at the scene of the crime, was now at least known to have been in Memphis the day of the murder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The car was also examined exhaustively—trunk, interior, ashtray, wheel hubs, paint scrapings, and the like—and all the physical evidence flown to Washington for further study by the FBI lab."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-13",
      "id": "ch07-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Mexican tourist visa stickers showed the car had been south of the border the previous fall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Birmingham, the FBI also produced some solid information about the mysterious Mr. Galt. The address listed on the car registration led the police to a run-down rooming house and its manager, Peter Cherpes. He remembered Galt as a seaman who stayed there from August to October 1967."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-14",
      "id": "ch07-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" A check of the Mustang’s previous owner turned up a Birmingham businessman, William Paisley, who had sold the car to Eric S. Galt for $1,995 in cash in August 1967."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-15",
      "id": "ch07-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("Meanwhile, a sticker pasted inside the Mustang’s left front door showed that it had been serviced at a Los Angeles garage in February. The garage’s records listed Galt’s local address as 1535 North Serrano Avenue. The landlady remembered him staying there from mid-November 1967 until January 21, 1968. She also recalled him as a quiet tenant who had no visitors and drove a white Mustang."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-16",
      "id": "ch07-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" Post office records showed that in January, when he left the Serrano apartment, Galt moved just a few blocks away to a seedy residential hotel, the St. Francis."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-17",
      "id": "ch07-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" He checked out of the St. Francis on March 17, the day King had been in Los Angeles, and gave his forwarding address as general post office delivery, Atlanta, Georgia."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-18",
      "id": "ch07-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" There his trail was lost.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although the FBI questioned hundreds of Gaits in the United States, none had the middle name Starvo, and none had traveled as had the man who was suspected of killing Dr. King. A check of social security and IRS records turned up nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the field hunt was filling in a picture of Eric Galt’s movements, the lab investigation in Washington found that fibers in the Mustang’s trunk and floor mats, as well as from a sweatshirt and jacket found abandoned in the car, matched fibers from the sheets and pillows in Room 5B at the Memphis rooming house. Hair found in the Mustang was similar to hair found on a brush in the bundle thrown away at Canipe’s store."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-19",
      "id": "ch07-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" The FBI now knew that whoever was in Room 5B was also the person who abandoned the Mustang in Atlanta the day after the murder. A handwriting comparison soon confirmed that Lowmeyer’s signature on the gun receipt at Aeromarine Supply on March 29 was written by the same man who signed the name Eric S. Galt at the New Rebel Motel in Memphis on April 3.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By mid-April, the FBI had learned a good deal more from interviewing people who knew Galt at his Los Angeles apartments: He had visited New Orleans the previous December, might have had a racial altercation at a local bar, and was a supporter of Alabama governor George Wallace for president. More significant, it turned out, someone remembered Galt talking about taking dance lessons. Agents scoured the area and finally discovered that he had taken a course at National Dance Studio in Long Beach."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-20",
      "id": "ch07-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" There, one of the teachers recalled him talking about bartending school. Soon the agents located the International School of Bartending on Sunset Boulevard."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-21",
      "id": "ch07-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" The school’s manager, Tomas Lau, had a photograph of Galt at the graduation ceremony. Galt was standing uncomfortably in a tight bartender’s jacket and crooked bow tie, with his eyes closed, holding his graduation certificate. Twelve hours later, Donald Wood, of Aeromarine Supply in Birmingham, picked that photo out of an eight-picture lineup, positively identifying him as Lowmeyer. The FBI now knew it had the first photo of its suspect.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("In the meantime, the FBI had examined all money orders recently purchased in the Los Angeles area, and found one an Eric Galt had made payable to the Locksmithing Institute of Little Falls, New Jersey. He had begun the correspondence course in locksmithing techniques from Montreal, Canada, and the last lesson had been sent to him at 113 Fourteenth Street, a cheap rooming house in the middle of Atlanta’s small hippie district."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-22",
      "id": "ch07-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" At first the Bureau watched the apartment, then sent in two agents disguised as hippies to rent an adjoining room, and finally broke into Galt’s room. There, along with John Birch Society pamphlets and a box of Nabisco crackers, they found a map of Atlanta. Not only did it have four circles drawn in pencil—near Dr. King’s home, the SCLC headquarters, the Ebenezer Baptist Church, and the Capitol Homes housing project (where the Mustang had been abandoned)—but it also produced a clear left thumbprint.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the rooming-house manager, Jimmie Garner, picked out the bartending photo of Galt as his tenant, the FBI knew the print in Atlanta belonged to the same Galt whose photo they had from Los Angeles."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-23",
      "id": "ch07-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" Although the Bureau had lifted twenty-six prints from the evidence in Memphis, only three were clear—one on the rifle, one on the Redfield scope, and the other on the binoculars. Other prints on the beer can, newspaper, and aftershave were similar but blurred."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-24",
      "id": "ch07-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Now the Bureau had prints to go with its photo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On April 17, the bartending graduation photo of Eric Starvo Galt was publicly released. Attorney General Clark announced that Eric S. Galt was wanted for a conspiracy, together with “an individual he alleged to be his brother,” to “injure, oppress, threaten, or intimidate” Dr. King."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn07-07-3",
      "id": "fn07-3"
    }
  }, [_vm._v("*")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-25",
      "id": "ch07-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On that same day, FBI fingerprint experts began matching prints at 9:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". The Bureau had narrowed the search to white men under fifty years of age, but that still left 53,000 sets of prints."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-26",
      "id": "ch07-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" It could take two months working day and night to get a match, assuming that Galt had his prints on file with the government.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Several FBI teams worked in shifts around the clock. Forty-eight hours later, shortly past 9:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". on April 19, they reached the seven-hundredth card and got lucky with a match. The name on the card was James Earl Ray, a forty-year-old ex-convict who was a four-time loser. From the age of twenty-four, Ray had spent twelve of his next sixteen years behind bars, mostly for robberies. He had escaped from Missouri State Penitentiary in April 1967, in the midst of serving a twenty-year sentence. Although he did not seem to fit the "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("mold of a murderer, there was no doubt that Ray was Galt. Later that day, April 19, the FBI made a public announcement, and this time provided mug shots of Ray over a ten-year span."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-27",
      "id": "ch07-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" Two hundred thousand wanted posters were soon distributed around the country, and thirty thousand were printed in Spanish for distribution in Mexico."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-28",
      "id": "ch07-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the FBI approached Ray’s two living brothers, John and Jerry, both ex-convicts, they refused to provide any help in finding James. Agents who interviewed John Ray noted that he was “initially uncooperative and told them, ‘What’s all the excitement about? He only killed a nigger. If he had killed a white man, you wouldn’t be here. King should have been killed ten years ago.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-29",
      "id": "ch07-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Jerry, meanwhile, told a friend that he would “tell the FBI only enough to keep them off my back.” Asked by the same friend if James had killed King, Jerry said, “This is his business. I didn’t ask him. If I was in his position and had eighteen years to serve and someone offered me a lot of money to kill someone I didn’t like anyhow, and get me out of the country, I’d do it.”"), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn07-07-4",
      "id": "fn07-4"
    }
  }, [_vm._v("*")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch07-07-30",
      "id": "ch07-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "image-left1"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn07-1",
      "id": "fn07-07-1"
    }
  }, [_vm._v("*")]), _vm._v(" At 6:36, the dispatcher reported a white Mustang driving north at a high rate of speed. For the next twelve minutes, the dispatcher received transmissions from a person who claimed to be broadcasting from a CB radio while giving hot pursuit to the fleeing Mustang. At one point, the CB broadcaster even yelled, “He’s shooting at me—he’s hit my windshield!” Police cars were diverted to this chase. Finally, the police realized the broadcasts were coming from a fixed location, not from a moving car. The broadcaster had led police cars at least six miles out of their way to the northeast corner of the city, when a logical escape route for the assassin would have been in the opposite direction. Was it part of a plot, a phony broadcast by a coconspirator to help the shooter leave the city? The problem with that hypothesis is the time of the hoax. It started thirty-five minutes after the shooting, at a time when the assassin would have already been safely in Arkansas or Mississippi, even if he had encountered heavy traffic. The broadcast would have done no good at that late stage. Moreover, the broadcaster used Channel 17, one of the lesser-used CB frequencies, not the best means of penetrating the police network. The Memphis police investigated and concluded that they had found the prankster, an eighteen-year-old high school student and CB enthusiast. However, while the House Select Committee questioned the accuracy of that conclusion, it did agree after an extensive investigation of the issue that the broadcast was not linked to a conspiracy in the assassination (MURKIN ME, Sub. D, section 2, pp. 116–19; HSCA Rpt., pp. 502–6).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn07-2",
      "id": "fn07-07-2"
    }
  }, [_vm._v("*")]), _vm._v(" More than a hundred American cities were hit with riots in the aftermath of the King assassination. Some 50,000 Army and Air Guardsmen assisted local law enforcement during the week to ten days that the violence continued. Twenty thousand regular Army troops backed up the Guardsmen. Two of the cities struck worst were the nation’s capital, with 11 dead, 1,200 injured, 7,600 arrested, and 1,200 fires; and nearby Baltimore, with 6 dead, 700 injured, 5,800 arrested, and 1,000 small businesses destroyed.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn07-3",
      "id": "fn07-07-3"
    }
  }, [_vm._v("*")]), _vm._v(" The original charge included Galt’s brother, since the owner of Aeromarine Supply, the Birmingham gun store where the murder weapon was purchased, remembered that the buyer had swapped the first rifle, a .243 caliber, for a .30-06, because his brother had told him he had bought the wrong gun.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn07-4",
      "id": "fn07-07-4"
    }
  }, [_vm._v("*")]), _vm._v(" John Ray, who has described himself as a “mild segregationist,” later told the House Select Committee that this statement was not reflective of his general view toward King in 1968. He testified, “I probably was drunk, if I did say that.” However, in a letter he wrote from prison to author George McMillan in June 1972, John said, “The common man … knows that King was not a saint as these try to picture him. There are millions of Rays in the United States with the same background and beliefs, who know that King was not only a rat but with his beaded eyes and pin ears looked like one.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1-1"
  }, [_vm._v("As for Jerry Ray, when asked about the accuracy of his statement, he said, “It might have been true. I can’t remember exactly what I said, but I have told other people. I said if he done it there had to be a lot of money involved because he wouldn’t do it for hatred or just because he didn’t like somebody, because this is not his line of work.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fd61d63","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter07.vue
// module id = 96
// module chunks = 0